// constants/searchOptions.ts

export const radiusOptions = [
  { label: "10 miles", value: "10" },
  { label: "15 miles", value: "15" },
  { label: "20 miles", value: "20" },
  { label: "25 miles", value: "25" },
  { label: "30 miles", value: "30" },
  { label: "35 miles", value: "35" },
  { label: "40 miles", value: "40" },
  { label: "45 miles", value: "45" },
  { label: "50 miles", value: "50" },
  { label: "100 miles", value: "100" },
];

export const RESUME_UPDATED_OPTIONS = [
  { label: "Any time", value: "" },
  { label: "Last 24 hours", value: "1440" },
  { label: "Last 2 days", value: "2880" },
  { label: "Last 3 days", value: "4320" },
  { label: "Last week", value: "10080" },
  { label: "Last month", value: "43200" },
  { label: "Last 3 months", value: "129600" },
  { label: "Last 6 months", value: "259200" },
  { label: "Last 9 months", value: "388800" },
  { label: "Last 12 months", value: "525600" },
  { label: "Custom range", value: "custom" },
];

export const salaryPerOptions = [
  { label: "Per Year", value: "per_year" },
  { label: "Per Hour", value: "per_hour" },
];

export const salaryAmountOptions = [
  { label: "Any", value: "" },
  { label: "$30,000+", value: "30000" },
  { label: "$50,000+", value: "50000" },
  { label: "$70,000+", value: "70000" },
  { label: "$90,000+", value: "90000" },
  { label: "$110,000+", value: "110000" },
  { label: "$130,000+", value: "130000" },
  { label: "$150,000+", value: "150000" },
];

export const educationOptions = [
  { label: "All Education Levels", value: "all" },
  { label: "High School / GED", value: "hs" },
  { label: "Associate Degree", value: "associate" },
  { label: "Bachelor's Degree", value: "bachelor" },
  { label: "Master's Degree", value: "master" },
  { label: "Doctorate", value: "phd" },
];

export const jobTypeOptions = [
  { label: "All Types", value: "all" },
  { label: "Full Time", value: "fulltime" },
  { label: "Part Time", value: "parttime" },
  { label: "Contract", value: "contract" },
  { label: "Seasonal", value: "seasonal" },
];

export const travelOptions = [
  { label: "No Travel Required", value: "none" },
  { label: "Up to 25%", value: "25" },
  { label: "Up to 50%", value: "50" },
  { label: "Up to 75%", value: "75" },
  { label: "100% Travel", value: "100" },
];

export const minuteKeyMap: Record<string, number> = {
  "24h": 1440,
  "7d": 10080,
  "30d": 43200,
  "90d": 129600,
};

// ── Job Types ────────────────────────────────────────────────────────
export const jobTypeAPIMap: Record<string, string> = {
  fullTime: "WantsPermanent",
  partTime: "WantsTemp",
  tempContract: "WantsContract",
  intern: "WantsIntern",
  seasonal: "WantsSeasonal",
};

// ── Security Clearances ─────────────────────────────────────────────
export const clearanceIDMap: Record<string, number> = {
  unspecified: 2,
  activeConfidential: 12,
  activeSecret: 4,
  activeTopSecret: 5,
  activeTopSecretSCI: 6,
  activeTSSCICIPoly: 19,
  activeTSSCIFSPoly: 20,
  otherActiveClearance: 21,
};

// ── Travel ────────────────────────────────────────────────────────────
export const travelMap: Record<string, string> = {
  "25": "UpTo25PercentTravel",
  "50": "UpTo50PercentTravel",
  "75": "UpTo75PercentTravel",
  "100": "OneHundredPercentTravel",
};

// ── Citizenship → legalStatuses ─────────────────────────────────────
export const citizenshipAPIMap: Record<string, string> = {
  usCitizen: "Citizen",
  permanentResident: "PermanentResident",
};

//Targeted Job Type

export const TARGET_JOB_TYPE_OPTIONS = [
  { value: "", label: "Any" },
  { value: "1", label: "Full Time" },
  { value: "2", label: "Part Time" },
  { value: "3", label: "Intern" },
  { value: "4", label: "Temp / Contract / Seasonal" },
];